import { useSelector } from 'react-redux';

import { CarrierEnums } from '../enums/carriers';
import Global from '../store/global-selectors';

// this list of carriers is currently hardcoded because there is no a good data source for this type of information.
// In the future, this information will probably be included in state.
const carriersWhichDoNotReturnRate = [CarrierEnums.RoyalMail.carrierId];

export const useDoesCarrierProvideRateByServiceId = (serviceId) => {
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));
  return !carriersWhichDoNotReturnRate.includes(service?.carrierId);
};
